import { compact, sum as esToolkitSum } from 'es-toolkit';
/**
 * Just a wrapper over es-toolkit `sum` function for easier use
 * @example sum(1, 2, null, 4, undefined) // returns 7
 * @example sum(null, undefined) // returns 0
 */
export const sum = (...values) => esToolkitSum(compact(values));
//# sourceMappingURL=sum.js.map